import * as React from 'react';

function useEventListener(eventName, handler, context) {
  React.useEffect(() => {
    const element = context ?? window;

    element.addEventListener(eventName, handler);

    return () => {
      element.removeEventListener(eventName, handler);
    };
  }, [context, eventName, handler]);
}

export default useEventListener;